import { render, staticRenderFns } from "./ViewMaintenanceDetail.vue?vue&type=template&id=56527cce&"
import script from "./ViewMaintenanceDetail.vue?vue&type=script&lang=js&"
export * from "./ViewMaintenanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewMaintenanceDetail.vue?vue&type=style&index=0&id=56527cce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports